import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, GlobalStyles } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Header from '../components/Header';
import Footer from '../components/Footer';

const faqs = [
  {
    question: "What is Screamify™?",
    answer: "Screamify™ is a revolutionary streaming platform dedicated exclusively to independent horror content. We're not just another streaming service – we're a community-driven platform that funds, promotes, and celebrates independent horror filmmaking."
  },
  {
    question: "How much does a subscription cost?",
    answer: "Screamify™ is committed to keeping horror accessible. Our subscription is just $2.99 per month, making it one of the most affordable streaming services available. This price point allows us to maintain a sustainable platform while ensuring most of our revenue goes toward supporting independent filmmakers."
  },
  {
    question: "What makes Screamify™ different from other streaming platforms?",
    answer: "Unlike traditional streaming platforms, Screamify™ reinvests a significant portion of subscription revenue directly into independent horror film production. We also host an annual film festival, run AI filmmaking contests, and actively seek out undiscovered horror talent. Our focus is solely on horror, allowing us to build a dedicated community of genre enthusiasts and creators."
  },
  {
    question: "What devices can I watch Screamify™ on?",
    answer: "We're developing apps for all major platforms including web browsers, iOS, Android, Apple TV, Roku, and Amazon Fire Stick. Our goal is to make independent horror accessible wherever you prefer to watch."
  },
  {
    question: "How can filmmakers submit their work to Screamify™?",
    answer: "We're actively seeking unique horror films that haven't been featured on major streaming platforms. If you're a filmmaker interested in having your work featured on Screamify™, join our waitlist and we'll contact you when our submission portal launches."
  },
  {
    question: "What is the Screamify™ Film Festival?",
    answer: "The Screamify™ Film Festival is our annual celebration of independent horror. It will feature selected works from our platform, new submissions, and special categories for AI-enhanced filmmaking. The festival aims to spotlight emerging talent and innovative approaches to horror storytelling."
  },
  {
    question: "How does Screamify™ support independent filmmakers?",
    answer: "We support independent filmmakers in multiple ways: through direct funding of new productions, revenue sharing from our platform, exposure through our annual film festival, and opportunities to experiment with AI filmmaking tools. Our lean operational model ensures more resources go directly to content creators."
  },
  {
    question: "When will Screamify™ launch?",
    answer: "We've secured $500,000 in seed funding and are actively developing our platform. Join our waitlist to be among the first to know when we launch and to receive exclusive early access offers."
  }
];

function FAQPage() {
  return (
    <Box 
      sx={{ 
        bgcolor: '#000000',
        minHeight: '100vh',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowX: 'hidden'
      }}
    >
      <GlobalStyles
        styles={{
          '.MuiAccordion-root': {
            '&:focus': {
              outline: 'none !important',
            },
            '&:focus-visible': {
              outline: 'none !important',
            },
          },
          '.MuiAccordionSummary-root': {
            '&:focus': {
              outline: 'none !important',
            },
            '&:focus-visible': {
              outline: 'none !important',
            },
          },
          '.MuiButtonBase-root': {
            '&:focus': {
              outline: 'none !important',
            },
            '&:focus-visible': {
              outline: 'none !important',
            },
          }
        }}
      />
      <Header />
      <Box
        sx={{
          pt: '84px',
          pb: '100px'
        }}
      >
        <Container 
          maxWidth="md"
          sx={{
            color: 'white',
            p: { xs: 2, sm: 4 }
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              color: '#ff0000',
              fontWeight: 600,
              mb: 4,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              textShadow: '0 0 10px rgba(255, 0, 0, 0.3)'
            }}
          >
            Frequently Asked Questions
          </Typography>

          <Box sx={{ mt: 4 }}>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                sx={{
                  bgcolor: 'transparent',
                  color: 'white',
                  borderBottom: '1px solid rgba(255, 0, 0, 0.2)',
                  '&:before': {
                    display: 'none',
                  },
                  '&.Mui-expanded': {
                    margin: 0,
                  },
                  boxShadow: 'none'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: '#ff0000' }} />}
                  sx={{
                    '&:hover': {
                      bgcolor: 'rgba(255, 0, 0, 0.1)',
                    },
                    '&.Mui-focused': {
                      bgcolor: 'rgba(255, 0, 0, 0.05)',
                    },
                    '& .MuiAccordionSummary-content.Mui-focused': {
                      color: '#ff0000',
                    },
                    '&:focus': {
                      outline: 'none',
                      bgcolor: 'rgba(255, 0, 0, 0.05)',
                    },
                    '&:focus-visible': {
                      outline: 'none',
                    },
                    transition: 'background-color 0.2s ease',
                    '&:hover, &:focus': {
                      borderLeft: '2px solid rgba(255, 0, 0, 0.5)',
                      paddingLeft: '6px',
                    }
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 500,
                      color: '#ff0000',
                    }}
                  >
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ opacity: 0.9, lineHeight: 1.8 }}>
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default FAQPage; 